export const GET_NOTES = 'shared/GET_NOTES';
export const ADD_NOTE = 'shared/ADD_NOTE';
export const ADD_TEMP_NOTE = 'shared/ADD_TEMP_NOTE';
export const REMOVE_NOTE = 'shared/REMOVE_NOTE';

export const GET_CONFIRM = 'shared/GET_CONFIRM';
export const SHOW_CONFIRM = 'shared/SHOW_CONFIRM';
export const CLOSE_CONFIRM = 'shared/CLOSE_CONFIRM';

export const ALERT_GET_UI_INFO = 'alerts/ALERT_GET_UI_INFO';
export const ALERT_SET = 'alerts/ALERT_SET';
export const ALERT_LOAD_LOGIN_ALERT = 'alerts/ALERT_LOAD_LOGIN_ALERT';
export const ALERT_MARK_AS_READ = 'alerts/MARK_AS_READ';

// App
export const APP_START = 'app/START';

// Auth
export const AUHT_LOGIN_SUCCESS = 'auth/AUHT_LOGIN_SUCCESS';
export const AUTH_LOGOUT_SUCCESS = 'auth/AUTH_LOGOUT_SUCCESS';
export const AUTH_SET_ME_MODEL = 'auth/AUTH_SET_ME_MODEL';
export const AUHT_LOGIN = 'auth/AUHT_LOGIN';
export const AUTH_LOGOUT = 'auth/AUTH_LOGOUT';
export const AUTH_STORE_ME = 'auth/AUTH_STORE_ME';
export const AUTH_GET_ROLE = 'auth/ROLE';
export const AUTH_GET_ME = 'auth/GET_ME';
export const AUTH_GET_ACCOUNT_ID = 'auth/ACCOUNT_ID';
export const AUTH_GET_AGENT_ID = 'auth/AGENT_ID';
export const AUTH_GET_COMPANY_ID = 'auth/COMPANY_ID';
export const AUTH_GET_IS_LOGGED = 'auth/IS_LOGGED_IN';

// Roles section
export const AUTH_HAS_ROLE_PERMISSIONS = 'auth/HAS_ROLE_PERMISSIONS';
export const AUTH_HAS_COMPANY_PERMISSIONS = 'auth/HAS_COMPANY_PERMISSIONS';
export const AUTH_HAS_ADMIN_PERMISSIONS = 'auth/HAS_ADMIN_PERMISSIONS';
export const AUTH_HAS_SUPERADMIN_PERMISSIONS =
    'auth/HAS_SUPERADMIN_PERMISSIONS';

// ApiData
// actions
export const APIDATA_DASHBOARD_ENTER = 'apidata/APIDATA_DASHBOARD_ENTER';
export const APIDATA_SITEMANUALS_ENTER = 'apidata/APIDATA_SITEMANUALS_ENTER';
// getters
export const APIDATA_GET_DASHBOARD = 'apidata/GET_DASHBOARD';
export const APIDATA_GET_SITEMANUALS = 'apidata/GET_SITEMANUALS';

// User DATA
export const USERDATA_SAVE_PERIOD = 'userdata/SAVE_PERIOD';
export const USERDATA_RESET_PERIOD = 'userdata/RESET_PERIOD';
export const USERDATA_GET_DEFAULT_PERIOD = 'userdata/GET_DEFAULT_PERIOD';
export const USERDATA_GET_ROUTER_QUERY = 'userdata/GET_ROUTER_QUERY';

// Permissions sections
export const AUTH_HAS_PERMISSION = 'auth/HAS_PERMISSION';
export const AUTH_HAS_PERMISSION_APPROVE_AGENTS =
    'auth/HAS_PERMISSION/APPROVE_AGENTS';

// Approve
export const APPROVE_UNAPPROVED_COUNT = 'approve/UNAPPROVED_COUNT';
export const APPROVE_SET_UNAPPROVED_COUNT = 'approve/SET_UNAPPROVED_COUNT';
export const APPROVE_SET_TIMER_UNAPPROVED_COUNT = 'approve/APPROVE_SET_TIMER_UNAPPROVED_COUNT';
export const APPROVE_UNSET_TIMER_UNAPPROVED_COUNT = 'approve/APPROVE_UNSET_TIMER_UNAPPROVED_COUNT';
export const APPROVE_START_TIMER_UNAPPROVED_COUNT = 'approve/APPROVE_START_TIMER_UNAPPROVED_COUNT';
export const APPROVE_END_TIMER_UNAPPROVED_COUNT = 'approve/APPROVE_END_TIMER_UNAPPROVED_COUNT';
export const APPROVE_QUERY_UNAPPROVED_COUNT = 'approve/QUERY_UNAPPROVED_COUNT';
